// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__o8CHX","content":"Layout_content__ik2xM"};